"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.split");
























































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      MenuList: [], title: '', newadd: false, sexList: [{ name: '男', value: 1 }, { name: '女', value: 0 }], searchData: { platform: '', sex: '', email: '', mobile: '', time: '', page: 1, // 当前页码
        rows: 10 // 页码条
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'email', label: '邮箱号', isShow: true }, { prop: 'mobile', label: '手机号', isShow: true }, { prop: 'nickName', label: '昵称', isShow: true }, { prop: 'sex', label: '性别', formatter: function formatter(row, column, value) {if (value === 0) {return '女';} else if (value === 1) {return '男';} else {return value;}}, isShow: true }, { prop: 'platform', label: '来源', isShow: true }, { prop: 'createTime', label: '注册时间', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'country', label: '国籍', isShow: true }, { prop: 'province', label: '省份', isShow: true }, { prop: 'city', label: '城市', isShow: true }, { prop: 'address', label: '实际地址', isShow: true }] };}, mounted: function mounted() {var self = this;self.init();}, methods: { init: function init() {var self = this;var params = Object.assign({}, self.searchData);if (params.time) {params.startTime = params.time[0] + ' 00:00:00';params.endTime = params.time[1] + ' 23:59:59';}delete params['time'];self.getData('/api/baseUser', params, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, // 设置imageList
    setImageList: function setImageList(val) {var arr = [];if (val) {arr.push(val);}this.imageSrcList = arr;}, resetFun: function resetFun() {// 重置
      this.searchData.sex = '';this.searchData.email = '';this.searchData.platform = '';this.searchData.time = '';this.searchData.mobile = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();
    },
    changeisForceFun: function changeisForceFun(val) {
      var self = this;
      self.searchData.type = '';
      if (val === '1') {
        self.searchData.type = '1';
      } else if (val === '2') {
        self.searchData.type = '2';
      }
    },
    onfileChange: function onfileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.newimg = files[0];
      this.imgPreview(files[0]);
    },
    excelFun: function excelFun() {
      var self = this;
      var day_30 = 3600 * 30 * 24 * 1000;
      // 校验时间是否填写
      if (self.searchData.startTime === '') {
        self.$message({
          message: '请选择开始时间',
          type: 'error' });

        return false;
      } else if (self.searchData.endTime === '') {
        self.$message({
          message: '请选择结束时间',
          type: 'error' });

        return false;
      } else if (self.searchData.endtime - self.searchData.starttime > day_30) {
        self.$message({
          message: '只能导出小于等于30天的的时间',
          type: 'error' });

        return false;
      }
      if (this.searchData.endTime) {
        var endTime = this.searchData.endTime;
        if (endTime.split(' ').length < 2) {
          endTime = endTime + ' 23:59:59';
          this.searchData.endTime = endTime;
        }
      }
      if (this.searchData.startTime) {
        var startTime = this.searchData.startTime;
        if (startTime.split(' ').length < 2) {
          startTime = startTime + ' 00:00:00';
          this.searchData.startTime = startTime;
        }
      }
      window.location.href = '/api/baseUser/export?startTime=' +
      self.searchData.startTime + '&endTime=' + self.searchData.endTime + '&platform=' + self.searchData.platform + '&sex=' + self.searchData.sex + '&email=' + self.searchData.email;
    },
    queryMenu: function queryMenu(item) {
      this.title = '查询设备';
      var self = this;
      self.getData('/api/faDeviceInfo/user/' + item.id, {}, function (res) {
        self.MenuList = res;
      });
      self.newadd = true;
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      // this.$refs['addForm'].resetFields()
      done();
      this.newadd = false;
    } } };exports.default = _default;